
import "./TestStyles.css";
import { handleOnPopState } from '../utils/pop_state_utils.js';
import React, { useState, useEffect, useCallback } from "react";
import { UpdateLocalStorage } from '../db/localstorage_utils.js';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { playInstructionsOnce, handleAudioEndedCommon } from '../utils/audio_utils.js';
import { calculate_progress } from "../utils/progress_bar.js";
 

const QuestionTenScreen = ({ userData }) => {
  const [audio] = useState(new Audio("/audio/q10_instructions.mp3"));
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const results = JSON.parse(localStorage.getItem("results"));
  const [nextPage] = useState("/Q11Screen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_10");  
  const handleAudioEnded = useCallback(() => {
    handleAudioEndedCommon({
      audio,
      onEnded: handleAudioEnded,
      setAudioPlayed,
      setButtonDisabled,
      setNextButtonStyle
    });
  }, [audio]);

   
  // Implementing the popstate handler
  window.onpopstate = () => {
    handleOnPopState({ results, userData, navigate, location });
  };

  useEffect(() => {   // Instructions effect
      if (!audioPlayed) {
        playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: handleAudioEnded });
      }
    }, [audio, audioPlayed, handleAudioEnded]); 

  /**
   * The handleChange function updates the selected value based on the value of the event target.
   * @param event - The event parameter is an object that represents the event that triggered the
   * handleChange function. In this case, it is likely an event object related to a change event, such
   * as a user selecting an option from a dropdown menu or changing the value of an input field.
   */
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress variant="custom" className="ProgressBar" value={calculate_progress('asymptotic', 17, 54)} max="1"></progress>
        <p className="Instructions">Write two complete sentences about your last weekend</p>
        <textarea placeholder="Enter sentence here" className="sentenceInput" onChange={handleChange} />
      </div>
      <div className="NextButtonContainer">
      <Link to={nextPage}>
          <button  disabled={buttonDisabled} onClick={() => UpdateLocalStorage(selectedValue, thisPage)} className={nextButtonStyle}>
            <img src="/icons/arrow.png" alt="Next Button" />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default QuestionTenScreen;
